import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { appName } from "../../app.json";
import Counter from "./partials/Counter";
import { Staff as STAFF_QUERY } from "../../queries/staff.query";
import { useQuery } from "react-apollo";
import LoadingSpinner from "../../partials/loading";
import { Doughnut } from "react-chartjs-2";
import { EventEmitter } from "../../event/EventEmitter";
import { EVENT_TARGET } from "../../event/model";

const Dashboard = () => {
    const title = "Staff Dashboard";
    const [items, setItems] = useState([]);
    const [dLabels, setDLabels] = useState([]);

    const { loading, data, refetch } = useQuery(STAFF_QUERY.QUERY.STAFFCOUNTS, {
        onCompleted: (data) => {
            const list = data.StaffCountByDesgination.map((i) => i.count);
            const labels = data.StaffCountByDesgination.map((i) => i.designation.name);
            setItems(list);
            setDLabels(labels);
        },
        notifyOnNetworkStatusChange: true,
    });

    EventEmitter.subscribe(EVENT_TARGET.STAFF, () => refetch());
    return (
        <>
            <Helmet>
                <title>
                    {title} | {appName}
                </title>
            </Helmet>

            <LoadingSpinner loading={loading} bar={true} />

            {!loading && data && (
                <>
                    <h3>Basic Staff Statistics</h3>
                    <div className="row">
                        {data && (
                            <>
                                <div className="col-md-4">
                                    <div className="row">
                                        <div className="col-md-12 fade-in">
                                            <Counter title="Total Number of Staff" icon="wc" count={data.TotalStaffCount} iconBg="bg-primary" />
                                        </div>

                                        <div className="col-md-12 fade-in">
                                            <Counter title="Total Number of New Staff" icon="group_add" count={data && data.NewStaffCount} iconBg="bg-success" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-8">
                                    <div className="row">
                                        <div className="col-md-6 fade-in">
                                            <Doughnut
                                                width={50}
                                                height={50}
                                                data={{
                                                    datasets: [
                                                        {
                                                            data: items,
                                                            backgroundColor: ["#28a745", "#fa5571", "#007bff", "##ffd200"],
                                                        },
                                                    ],
                                                    labels: dLabels,
                                                }}
                                                options={{
                                                    animation: {
                                                        animateScale: true,
                                                    },
                                                    maintainAspectRatio: true,
                                                    cutoutPercentage: 60,
                                                }}
                                            />
                                        </div>
                                        <div className="col-md-6 fade-in">
                                            <Doughnut
                                                width={50}
                                                height={50}
                                                data={{
                                                    datasets: [
                                                        {
                                                            data: data.StaffCountByType.map((i) => i.count),
                                                            backgroundColor: ["#8E44AD", "#007bff", "#E67D21", "#28a745"],
                                                        },
                                                    ],
                                                    labels: data.StaffCountByType.map((i) => i.type.name),
                                                }}
                                                options={{
                                                    animation: {
                                                        animateScale: true,
                                                    },
                                                    maintainAspectRatio: true,
                                                    cutoutPercentage: 60,
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>

                    <h3>Staff Statistics by Designation</h3>
                    <div className="row">
                        {data && (
                            <>
                                {data.StaffCountByDesgination.map((desCount, idx) => (
                                    <div key={idx} className="col-md-4 fade-in">
                                        <Counter title={`Number of ${desCount.designation.name}s`} icon="people_alt" count={desCount.count} iconBg="bg-orange" />
                                    </div>
                                ))}
                            </>
                        )}
                    </div>

                    <h3>Staff Statistics by Type</h3>
                    <div className="row">
                        {data && (
                            <>
                                {data.StaffCountByType.map((typeCount, idx) => (
                                    <div key={idx} className="col-md-4 fade-in">
                                        <Counter title={`${typeCount.type.name} Staff`} icon="people" count={typeCount.count} iconBg="bg-purple" />
                                    </div>
                                ))}
                            </>
                        )}
                    </div>
                </>
            )}
        </>
    );
};

export default Dashboard;
